import { station2Slice } from './station2.slice.ts';

const { updateSelectedPost } = station2Slice.actions;

export const updateStationTwoSelectedPost = updateSelectedPost;
